import { ActionTypes, Actions } from '../actions/dynamic-dns.action';
import { DynamicDns } from '../models/dynamic-dns.model';

export const initialState: DynamicDns | null = null;

export function dynamicDnsReducer(state: DynamicDns | null = initialState, action: Actions) {
  switch (action.type) {
    case ActionTypes.SET_DYNAMIC_DNS_CONFIGURATION:
      return {
        ...state,
        ...action.payload,
      };
    case ActionTypes.UPDATE_DYNAMIC_DNS_CONFIGURATION:
      return {
        ...state,
        ...action.payload,
      };
    case ActionTypes.RESET_DYNAMIC_DNS_CONFIGURATION:
      return initialState;
    default:
      return state;
  }
}
